function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10,
  fill: "#7056FA"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.035 7.368c.62-.063 1.11-.582 1.11-1.184A1.248 1.248 0 0010.908 5c-.683 0-1.217.54-1.217 1.184 0 .207.064.394.15.581l.427 5.96h4.484l1.836 4.196L19 16.007l-.385-.872-1.324.457-1.772-3.988-4.164.021-.085-.748h3.01V9.756h-3.138c.021 0-.107-2.388-.107-2.388z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.541 15.924c-.747 1.454-2.349 2.41-4.036 2.41C9.028 18.333 7 16.36 7 13.95c0-1.703 1.046-3.281 2.626-3.967l.107 1.288a3.17 3.17 0 00-1.516 2.68c0 1.744 1.473 3.177 3.267 3.177 1.644 0 3.053-1.226 3.246-2.804l.811 1.6z",
  fill: "#fff"
});

function SvgAccessibilityPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgAccessibilityPurple;